export enum Background {
  LIGHT,
  DARK,
}